var $2c38dbfaf041a865$exports = {};
$2c38dbfaf041a865$exports = {
  "close": "\uB2EB\uAE30",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC54C\uB9BC");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), "\uAC1C \uC54C\uB9BC");
      }
    }), ".");
  }
};
export { $2c38dbfaf041a865$exports as default };